// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchPanel_searchInput__CVebV"};